import * as firebase from 'firebase'

var config = {
    apiKey: "AIzaSyAxjRyHfG-56JqtcgDz-X1NbeP3eEgd3Gk",
    authDomain: "parallebs-students.firebaseapp.com",
    databaseURL: "https://parallebs-students.firebaseio.com",
    projectId: "parallebs-students",
    storageBucket: "parallebs-students.appspot.com",
    messagingSenderId: "744536450698"
};

firebase.initializeApp(config);

const auth = firebase.auth()
const database = firebase.firestore()
const storage = firebase.storage()
const functions = firebase.functions()

export {auth, database, storage, functions}


// WEBPACK FOOTER //
// ./src/firebaseconfig.js